export class PaginateCollection<T> {
  constructor(
    public count: number = 0,
    public page: number = 1,
    public perPage: number = 25,
    public list: T[] = []
  ) {}
}
